import * as madlibOptionsActions from '../actions/madlib-options-actions';
import { IMadlibOptions } from './../../shared/services/mad-lib-services/mad-lib-helpers';

export interface IMadlibOptionsState {
  loading: boolean;
  loaded: boolean;
  madlibOptionsEntity: IMadlibOptions;
}

export const initialState: IMadlibOptionsState = {
  loading: false,
  loaded: false,
  madlibOptionsEntity: null,
};

export function reducer(
  state: IMadlibOptionsState = initialState,
  action: madlibOptionsActions.MadlibOptionsAction,
): IMadlibOptionsState {
  switch (action.type) {
    case madlibOptionsActions.LOAD_MADLIB_OPTIONS:
      return {
        ...state,
        loading: true,
      };
    case madlibOptionsActions.LOAD_MADLIB_OPTIONS_SUCCESS:
      const madlibOptionsEntity = action.payload;
      return {
        ...state,
        loading: false,
        loaded: true,
        madlibOptionsEntity,
      };
    case madlibOptionsActions.LOAD_MADLIB_OPTIONS_FAIL:
      return { ...state, loading: false, loaded: false };
    default:
      return state;
  }
}
